module.exports = __webpack_public_path__ + "static/media/health-management_p3_3.47e517ed.png";